app.directive('print', ['$window', function($window){
    return {
        restrict: 'A',
        link: function(scope, element, attr, ctrl){
            element.click(function(){
                $window.print();
            });
        }
    };
}]);